<div class="pagination" *ngIf="totalPages > 1">
  <button
    class="pagination-btn"
    [disabled]="!hasPrevious"
    (click)="goToFirst()"
    [title]="firstPageText"
  >
    ««
  </button>
  <button
    class="pagination-btn"
    [disabled]="!hasPrevious"
    (click)="goToPrevious()"
    [title]="previousPageText"
  >
    ‹
  </button>
  
  <span *ngFor="let page of getPageNumbers()" class="pagination-pages">
    <button 
      class="pagination-btn page-number"
      [class.active]="page === number"
      (click)="goToPage(page)"
    >
      {{ page + 1 }}
    </button>
  </span>

  <button
    class="pagination-btn"
    [disabled]="!hasNext"
    (click)="goToNext()"
    [title]="nextPageText"
  >
    ›
  </button>
  <button
    class="pagination-btn"
    [disabled]="!hasNext"
    (click)="goToLast()"
    [title]="lastPageText"
  >
    »»
  </button>

  <span class="pagination-info">
    {{ pageInfoResolved }}
  </span>
</div>
